import { useEffect, useState } from 'react';
import { Toaster as Sonner } from 'sonner';

function useHtmlTheme(): 'dark' | 'light' {
    const [theme, setTheme] = useState<'dark' | 'light'>(() =>
        document.documentElement.classList.contains('dark') ? 'dark' : 'light',
    );

    useEffect(() => {
        const sync = () => {
            setTheme(document.documentElement.classList.contains('dark') ? 'dark' : 'light');
        };
        const observer = new MutationObserver(sync);
        observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
        return () => observer.disconnect();
    }, []);

    return theme;
}

export function Toaster() {
    const theme = useHtmlTheme();
    return (
        <Sonner
            theme={theme}
            position="bottom-right"
            richColors
            closeButton
            toastOptions={{ className: 'text-sm' }}
        />
    );
}
